import { getVisibilityColumns } from '@components/ColumnsVisibilityToggle/getVisibilityColumns';

import { columns } from './columns';

const saleDetailsVisibilityColumns = getVisibilityColumns(columns);

export { saleDetailsVisibilityColumns };
